import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { NavigationType } from "web_myplann/Utils/WebViewModel";

export type AppInfoState = {
	appVersion: string;
};

const defaultState: AppInfoState = {
	appVersion: "unknown",
};

export const appInfoState = atomWithStorage<AppInfoState>(
	"MYPLANN_APP_INFO_STATE",
	defaultState,
);

export const biometryEnabledState = atom(false);

export const supportedNavigationTypesState = atom<
	readonly NavigationType[] | undefined
>(undefined);
